:host {
  --uui-cb-color: var(--uui-theme-on-background);
  --uui-cb-bg-color: transparent;
  --uui-cb-border-color: var(--uui-cb-color);

  --uui-cb-hover-color: var(--uui-theme-core-400);
  --uui-cb-bg-hover-color: var(--uui-cb-hover-color);
  --uui-cb-border-hover-color: var(--uui-cb-hover-color);
  --uui-cb-border-width: 2px;

  --uui-cb-checked-color: var(--uui-cb-color);
  --uui-cb-bg-checked-color: var(--uui-theme-core-600);
  --uui-cb-border-checked-color: var(--uui-cb-checked-color);

  --uui-cb-active-color: var(--uui-theme-core-600);
  --uui-cb-bg-active-color: var(--uui-cb-active-color);
  --uui-cb-border-active-color: var(--uui-cb-active-color);

  --uui-cb-border-focus-color: var(--uui-cb-border-color);

  --uui-cb-line-height: var(--uui-default-line-height);
  --uui-cb-label-width: inherit;
}

/* Non-variable host values */
:host {
  display: var(--uui-cb-display, flex);
  font-family: var(--uui-primary-font-family);
  font-size: var(--uui-default-font-size, 16px);
}

:host[error] {
  --uui-cb-color: var(--uui-theme-error-600);
  --uui-cb-bg-color: var(--uui-theme-error-600);
  --uui-cb-border-color: var(--uui-theme-error-600);

  --uui-cb-hover-color: var(--uui-theme-error-600);
  --uui-cb-bg-hover-color: var(--uui-theme-error-600);
  --uui-cb-border-hover-color: var(--uui-theme-error-600);

  --uui-cb-active-color: var(--uui-theme-error-600);
  --uui-cb-bg-active-color: var(--uui-cb-active-color);
  --uui-cb-border-active-color: var(--uui-cb-active-color);

  --uui-cb-checked-color: var(--uui-cb-color);
  --uui-cb-bg-checked-color: var(--uui-cb-bg-color);
  --uui-cb-border-checked-color: var(--uui-cb-checked-color);
}



input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 0;
  box-sizing: border-box;
}

input[type="checkbox"] + label {
  color: var(--uui-cb-color);
}

input[type="checkbox"] + label {
  box-sizing: border-box;
  position: relative;
  top: 0;
  padding-left: 2em;
  cursor: pointer;
  line-height: var(--uui-cb-line-height);
  margin-bottom: var(--uui-checkbox-margin-bottom, 1);
  width: var(--uui-cb-label-width, inherit);
}

input[type="checkbox"] + label::before,
input[type="checkbox"] + label::after {
  position: absolute;
  display: inline-block;
}

/* This draws the actual box that the check appears in */
input[type="checkbox"] + label::before {
  box-sizing: border-box;
  content: "";
  top: 0;
  left: 0;
  height: 1.5em;
  width: 1.5em;
  border-radius: var(--uui-border-radius-sm);
  border-style: solid;
  border-width: 1px;
}

input[type="checkbox"] + label::before {
  border-color: var(--uui-cb-border-color);
}

:host([indeterminate]:not([indeterminate="false"])) input[type="checkbox"] + label::before,
input[type="checkbox"]:checked + label::before {
  border-color: var(--uui-cb-bg-checked-color);
  background-color: var(--uui-cb-bg-checked-color);
}


input[type="checkbox"] + label:hover::before {
  border-width: var(--uui-cb-border-width);
  border-color: var(--uui-cb-border-hover-color);
}


input[type="checkbox"] + label::after {
  left: 0;
  top: 0.17em; /* compensate for SVG framing */
  content: none;
  height: 1em;
  width: 1em;
}

input[type="checkbox"]:active + label::after,
input[type="checkbox"]:checked + label::after {
  content: var(--uui-cb-checkbox-icon-url);
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  top: 0.4em;
  left: 0.25em;
}

input[type="checkbox"]:checked + label::before {
  border: 0;
}

:host([indeterminate]:not([indeterminate="false"])) input[type="checkbox"] + label::after {
  content: var(--uui-cb-checkbox-determinate-icon-url);
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  left: 0.25em;
  top: 0;
}


/* ensure checkbox has focus to enable accessibility*/
input[type="checkbox"]:focus + label::before {
  outline: none;
  border-width: 2px;
  border-color: var(--uui-cb-border-checked-color);
}

/** disabled state */
input[type="checkbox"]:disabled + label {
  pointer-events: none;
  opacity: var(--uui-disabled-opacity);
}
